import { LeadSuccessModule } from './../lead-success/lead-success.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { InputModule } from './../input/input.module';
import { IntlInputModule } from './../intl-input/intl-input.module';
import { ExitIntentComponent } from './components/exit-intent/exit-intent.component';
import { ButtonModule } from '../button/button.module';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [ExitIntentComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputModule,
    IntlInputModule,
    ButtonModule,
    LeadSuccessModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule
  ],
  exports: [ExitIntentComponent]
})
export class ExitIntentModule { }
